import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { retryWithLastVisitedUrl } from "@utils";
import UserMenu from "@components-shared/mobile/user-menu/UserMenu";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";
import { useRootAppStore } from "@hooks";
import { MobilePlatform } from "@state/stores/types";

export default observer(function ConnectionLostPage(props: {
	full?: boolean;
	isNavMenuOpen?: boolean;
	setIsNavMenuOpen: (newValue: boolean) => void;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore<MobilePlatform>();

	if (
		isCapacitorPlatform() &&
		!rootStore.capacitorConnectionStatusStore.connectionStatus?.connected
	) {
		return (
			<>
				<div className="container container--base">
					<div className="card">
						<div className="card__body u-type--center">
							<i className="u-icon u-icon--huge u-icon--alert-circle u-color--sent--danger u-mar--bottom--xsml" />
							<div className="card__title u-type--big">
								{t("CONNECTION_LOST_PAGE.TITLE")}
							</div>
						</div>
						<div className="card__body u-type--center">
							{t("CONNECTION_LOST_PAGE.MESSAGE")}
						</div>
						<div className="card__footer">
							<button
								type="button"
								className="at-ErrorCta card__footer__btn btn btn--base btn--block btn--accent"
								onClick={retryWithLastVisitedUrl}
							>
								{t("COMMON.RETRY")}
							</button>
						</div>
					</div>
				</div>
				{props.isNavMenuOpen && (
					<UserMenu
						isNavMenuOpen={props.isNavMenuOpen}
						setIsNavMenuOpen={props.setIsNavMenuOpen}
					/>
				)}
			</>
		);
	}

	if (props.full) {
		return (
			<>
				<div className="container container--base">
					<div className="card">
						<div className="card__body u-type--center">
							<i className="u-icon u-icon--huge u-icon--alert-circle u-color--sent--danger u-mar--bottom--xsml" />
							<div className="card__title u-type--big">
								{t("CONNECTION_LOST_PAGE.TITLE")}
							</div>
						</div>
						<div className="card__body u-type--center">
							{t("CONNECTION_LOST_PAGE.MESSAGE")}
						</div>
						<div className="card__footer">
							<button
								type="button"
								className="at-ErrorCta card__footer__btn btn btn--base btn--block btn--accent"
								onClick={retryWithLastVisitedUrl}
							>
								{t("COMMON.RETRY")}
							</button>
						</div>
					</div>
				</div>
				{props.isNavMenuOpen && (
					<UserMenu
						isNavMenuOpen={props.isNavMenuOpen}
						setIsNavMenuOpen={props.setIsNavMenuOpen}
					/>
				)}
			</>
		);
	}

	return (
		<>
			<div className="container container--base">
				<div className="card">
					<div className="card__body u-type--center">
						<i className="u-icon u-icon--huge u-icon--empty u-icon--sync"></i>
						<div className="card__title u-type--big">
							{t("CONNECTION_LOST_PAGE.TITLE")}
						</div>
					</div>
					<div className="card__body u-type--center">
						<div>{t("CONNECTION_LOST_PAGE.MESSAGE")}</div>
					</div>
					<div className="card__footer">
						<button
							type="button"
							className="at-ErrorCta card__footer__btn btn btn--base btn--block btn--accent"
							onClick={retryWithLastVisitedUrl}
						>
							{t("COMMON.RETRY")}
						</button>
					</div>
				</div>
			</div>
			{props.isNavMenuOpen && (
				<UserMenu
					isNavMenuOpen={props.isNavMenuOpen}
					setIsNavMenuOpen={props.setIsNavMenuOpen}
				/>
			)}
		</>
	);
});
